window.addEventListener('DOMContentLoaded', () => {
    const swiperContainers = document.querySelectorAll('.js-theme-cards-container');

    if (swiperContainers.length) {
        swiperContainers.forEach((container) => {
            const handleSwiperClasses = () => {
                const itemsContainer = container.querySelector('.js-theme-cards-items');
                itemsContainer.classList.add('swiper-wrapper');

                const items = itemsContainer.querySelectorAll(':scope > *');
                [].forEach.call(items, (item) => {
                    item.classList.add('swiper-slide');
                });
            };

            const activateSwiper = (container) => {
                handleSwiperClasses();

                new Swiper(container, {
                    slidesPerView: 'auto',
                    watchOverflow: true,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            };

            activateSwiper(container);
        });
    }
});
